export enum MembershipTier {
  ONE = 'ONE',
  PEAK = 'PEAK',
  LIFE = 'LIFE',
}

export enum PlanTypes {
  ANNUAL = 'annual',
  TWO_YEAR = 'twoYear',
  FAMILY = 'family',
  TRIAL = 'trial', //subscriptionType on variants is lowercase
}

export enum DeviceGeneration {
  HARVARD = 'HARVARD',
  GOOSE = 'GOOSE',
  MAVERICK = 'MAVERICK',
}
